module.exports = __webpack_public_path__ + "assets/imgs/news-page-img-5.v1.jpg";